<template>
  <!-- footer start-->
  <div class="common-footer">
    <div class="botbar">
      <div class="botbar-footer clearfix">
        <ul>
          <li>
            <h1>排版软件技术交流</h1>
            <p><span class="p-01"></span><span>4007-789-600（服务热线）</span></p>
            <p><span class="p-02"></span><span>ccts@founder.com.cn</span></p>
            <!-- <p><span class="p-03"></span><span>78646382（飞翔技术交流QQ群）</span></p> -->
            <p><span class="p-03"></span><span>647564500（飞翔技术交流QQ群）</span></p>
            <!-- <p><span class="p-03"></span><span>189630333（书版技术交流QQ群）</span></p> -->
            <h1>方正字库售前咨询</h1>
            <p><span class="p-01"></span><span>010-82531376（黄老师）</span></p>
            <!-- <p><span class="p-01"></span><span>010-82531376（黄老师）</span></p> -->
            <p><span class="p-01"></span><span>010-82531382（邓老师）</span></p>
            <!-- <p><span class="p-02"></span><span>yh.huang@founder.com.cn</span></p> -->
            <p><span class="p-02"></span><span>yh.huang@founder.com</span></p>
            <p><span class="p-02"></span><span>denghanwen@founder.com</span></p>
            <p><span class="p-03"></span><span>1021642507或842561793</span></p>
          </li>
          <li>
            <h1>排版软件售前咨询</h1>
            <p><span class="p-01"></span><span>010-82531412或15931182103（刘老师）</span></p>
            <p><span class="p-01"></span><span>010-82531449或17610331158（陈老师）</span></p>
            <p><span class="p-01"></span><span>010-82531751或13436861163（周老师）</span></p>
            <p><span class="p-02"></span><span>ccts@founder.com.cn</span></p>
            <p><span class="p-03"></span><span>873504364</span></p>
            <h1>关于我们</h1>
            <p><a :href="contextPath + '/staticpage/help_center_protocol.jhtml'" id="ft_help_center_protocol" target="view_window">条款与须知</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_declaration.jhtml'" id="ft_help_center_declaration" target="view_window">软件服务平台说明</a></p>
            <p><a href="//www.founder.com.cn/" id="ft_founder" target="_blank">方正电子</a></p>
            <h1>意见与投诉</h1>
            <p><span class="p-01"></span><i class="icon icon-21"></i>技术服务热线 4007-789-600</p>
          </li>
          <li>
            <h1>服务与支持</h1>
            <p><a :href="contextPath + '/staticpage/help_center_lockBindCode.jhtml'" id="help_center_lockBindCode" target="view_window">飞翔正版验证</a></p>
            <p><a :href="contextPath + '/userTheAgent/lockBindCode.jhtml'" id="ft_feitengcardreg" target="_blank">年服务版充值地址</a></p>
            <h1>在线帮助</h1>
            <p><a :href="contextPath + '/staticpage/help_center.jhtml'" id="ft_help_center" target="view_window">注册与登录说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_account.jhtml'" id="ft_help_center_account" target="view_window">账号设置说明</a></p>
            <p><a :href="contextPath + '/staticpage/purchasepayment.jhtml'" id="ft_purchasepayment" target="view_window">购买与支付说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_shipping.jhtml'" id="ft_help_center_shipping" target="view_window">发票与物流说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_trial.jhtml'" id="ft_help_center_trial" target="view_window">试用申请说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_download.jhtml'" id="ft_help_center_download" target="view_window">下载与安装说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_manual.jhtml'" id="ft_help_center_manual" target="view_window">软件使用说明</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_faq.jhtml'" id="ft_help_center_faq" target="view_window">常见问答FAQ</a></p>
            <p><a :href="contextPath + '/staticpage/help_center_h5.jhtml'" id="ft_help_center_h5" target="view_window">飞翔H5使用说明</a></p>
          </li>
          <li class="ewm">
            <h1>社交媒体</h1>
            <p><img src="@imgs/home/ewm1.jpg" /></p>
            <p>方正飞翔官方微信号</p>
            <p><img src="@imgs/home/ewm2.jpg" /></p>
            <p>方正飞翔官方公众号</p>
            <p><img src="@imgs/home/ewm3.jpg" /></p>
            <p>方正飞翔技术交流QQ群</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="botbq">
      <div class="botbq-footer clearfix">
        <div class="fl">
          <a id="ft-support" :href="contextPath + '/staticpage/help_center.jhtml'" target="view_window">服务与支持</a>&nbsp;
          <a id="ft-about" href="//www.founder.com.cn/AboutUs/CompanyIntroduction/index.html" target="view_window">关于方正电子</a>
        </div>
        <div class="fr">Copyright©2017-{{ endYear }} Founder .All rights reserved <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备09064830号-10</a></div>
      </div>
    </div>
  </div>
  <!-- footer end-->
</template>

<script>
export default {
  name: 'commerFooter',
  data() {
    return {
      contextPath: window.PROJECT_CONFIG.BASE_URL
    }
  },
  computed: {
    endYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.common-footer {
  width: 100%;
  height: 510px;
  // color: #fff;
  background-color: #414141;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 0;
  bottom: 0;
  .botbar {
    width: 100%;
    height: 430px;
    margin: 30px 0 0 0;
    .botbar-footer {
      width: 1050px;
      height: 100%;
      margin: 0 auto;
      ul {
        width: 100%;
        height: 100%;
        li:first-child {
          margin-left: 0px;
        }
        li:nth-child(2),
        li:nth-child(3),
        li:nth-child(4) {
          margin-left: 0px;
        }
        li:first-child,
        li:nth-child(2),
        li:nth-child(3) {
          float: left;
        }
        li:nth-child(2),
        li:nth-child(3) {
          margin-left: 77px;
        }
        li {
          h1 {
            font-size: 14px;
            color: #fff;
          }
          p {
            font-size: 12px;
            color: #959595;
            display: flex;
            a {
              color: #adadad;
            }
            a:hover {
              color: #d9d9cb;
            }
            .p-01 {
              display: inline-block;
              width: 16px;
              height: 14px;
              background: url('../../assets/imgs/footer/footer-01.png') no-repeat;
              background-position: 0 2%;
              background-size: cover;
              margin-right: 5px;
            }
            .p-02 {
              display: inline-block;
              width: 16px;
              height: 14px;
              background: url('../../assets/imgs/footer/footer-01.png') no-repeat;
              background-position: 0 44%;
              background-size: cover;
              margin-right: 5px;
            }
            .p-03 {
              display: inline-block;
              width: 16px;
              height: 14px;
              background: url('../../assets/imgs/footer/footer-01.png') no-repeat;
              background-position: 0 100%;
              background-size: cover;
              margin-right: 5px;
            }
          }
        }
        li:nth-child(4) {
          float: right;
          // margin-left: 180px;
          img {
            width: 83px;
            height: 83px;
          }
        }
        .ewm {
          width: 200px;
          border-left: 1px solid #767676;
          padding: 0 0 0 50px;
          min-height: 220px;
          h1 {
            text-align: center;
          }
          p {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .botbq {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    clear: left;
    .botbq-footer {
      width: 1000px;
      height: 50px;
      margin: 0 auto;
      color: #a1a1a1;
      .fl {
        width: 30%;
        float: left;
        a:nth-child(2) {
          margin-left: 10px;
        }
      }
      .fr {
        width: 68%;
        color: #a1a1a1;
        text-align: right;
        float: right;
      }
    }
  }
}
a {
  color: #a1a1a1;
  text-decoration: none;
}
a:hover {
  color: #d9d9cb;
}
</style>
